import React from 'react';
import { VStack, Box, Text } from '@chakra-ui/react';
import { mainpod } from '../../copy';

export const MainContent = () => {
	const handleClick = () => {
		window.open('mailto:jenna@vinemedical.com?subject=Consultation Request');
	};

	return (
		<VStack className='main-container' align='left'>
			<Box className='main-headline-box'>
				<Text className='main-headline'>{mainpod.headline}</Text>
			</Box>
			<Box>
				<Text className='main-body'>{mainpod.body}</Text>
			</Box>

			<Box
				as='button'
				onClick={handleClick}
				color='#e2796f'
				bg='rgba(0, 0, 0, 0)'
				borderColor='#e2796f'
				borderWidth='1px'
				transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
				_hover={{
					bg: '#e2796f',
					color: 'white',
					borderColor: '#e2796f',
					borderWidth: '1px'
				}}
				className='main-button'
			>
				{mainpod.button}
			</Box>
		</VStack>
	);
};
